<template>
  <footer class="">
    <div class="text-white text-center py-5">
      <p>
        <gh-btn
          href="https://github.com/terryz"
          data-size="large"
          data-show-count="true"
          aria-label="Follow @terryz on GitHub"
        >
          Follow @terryz
        </gh-btn>
      </p>
      <p class="font-monospace">
        <a
          :href="baseImgUrl"
          target="_blank"
          class="text-dark"
        ><i18n path="common.jqSeries" /></a>
      </p>
      <div>
        <span class="font-monospace me-2">Copyright © 2016 - {{ year }}</span>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['baseImgUrl']),
    year () {
      return new Date().getFullYear()
    }
  },
}
</script>
